import { render } from "./ModalSlot.vue?vue&type=template&id=6aab432f"
import script from "./ModalSlot.vue?vue&type=script&lang=ts"
export * from "./ModalSlot.vue?vue&type=script&lang=ts"
script.render = render

export default script